import { slideToggle, toggleAria, trapFocus } from "../utils.js";
import "core-js/es/array";

export default class Nav {
  constructor() {
    window.addEventListener("load", () => {
      //this is burger button
      this.navBtn = document.querySelector(".js-nav-btn");


      this.L2subnavBtn = document.querySelectorAll(".js-sub-nav2-btn");
      this.L3subnavBtn = document.querySelectorAll(".js-sub-nav3-btn");
      this.nav = document.querySelector(".js-hd");

      this.subNavBtns = Array.from(
        document.querySelectorAll(".js-sub-nav-btn")
      );

      this.navANoLink = Array.from(
        document.querySelectorAll(".js-nav-no-link")
      );

      this.pageNav = document.getElementById("js-page-nav");
      if (this.pageNav) {
        this.pageNavOffsetTop = this.pageNav.offsetTop || null;
        this.pageNavSticking = false;
      }

      this.searchBtn = document.querySelector(".js-search-btn");
      this.searchBox = document.querySelector(".js-search-box");
      this.closeSearchBtn = document.querySelector(".js-close-search");
      this.searchBoxActive = false;

      // Nav breeakpoint. This is set in the css so needs to match
      this.navBP = 1170;

      this.scrollFromTop = 0;
      this.lastScrollFromTop = 0;
      this.navFixed = false;
      this.navSlideIn = false;
      this.navAnimating = false;
      this.searchOverlayClose = true;

      // if there are any tabs on the page then init
      if (this.navBtn) this.init();
    });
  }

  init() {
    this.navANoLink.forEach((btn) =>
      btn.addEventListener("click", (ev) => this.navNoLinkClick(btn))
    );
    this.navBtn.addEventListener("click", (e) => this.navOpen());
    this.searchBtn.addEventListener("click", (e) => {
      this.toggleSearch(e)
      this.timeoutSearch();
    });
    this.closeSearchBtn.addEventListener("click", (e) => this.toggleSearch(e));
    this.L2subnavBtn.forEach((btn) => {
      btn.addEventListener("click", () =>{
        btn.classList.toggle("active");
        let subNav2 = btn.parentElement.querySelector(".c-hd-nav__ul--sub-2");
        slideToggle(subNav2);
      });
    });

    this.L3subnavBtn.forEach((btn) => {
      btn.addEventListener("click", () =>{
        btn.classList.toggle("active");
        let subNav3 = btn.parentElement.nextElementSibling;
        slideToggle(subNav3);
      });
    });


    // Moved this into a function as these need to unbind etc based on the window resize below
    this.bindNavEvents();
  }

  bindNavEvents() {
    // using a function style so is possible to removeEventListeners
    // https://www.webknit.co.uk/library/JS/events/#removing-anonymous-event-listeners
    const eventFunc = (ev) => {
      this.subNavClick(ev, ev.target);
    };

    // Binds all the scroll events
    const eventFunc2 = (e) => {
      // Global variable store distance from top
      this.scrollFromTop =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollFromTop;

      this.searchBox.classList.remove("active");

      // Nav scroll before page scroll stuff as dependant on it
      this.navScroll(e);

      // If we have a page nav
      if (this.pageNav) {
        this.pageNavScroll(e);
      }
    };

    // Controls the binding and unbinding
    const binds = () => {
      // Get rid of events both for click and keydown
      this.subNavBtns.forEach((btn) => {
        btn.removeEventListener("keydown", eventFunc);
        btn.removeEventListener("click", eventFunc);
      });

      window.removeEventListener("scroll", eventFunc2);

      // Check window size and re-bind events
      if (window.innerWidth >= this.navBP) {
        this.subNavBtns.forEach((btn) =>
          btn.addEventListener("keydown", eventFunc)
        );
        window.addEventListener("scroll", eventFunc2);
      } else
        this.subNavBtns.forEach((btn) =>
          btn.addEventListener("click", eventFunc)
        );
    };

    binds();

    // creating a settimeout and calling the bind event when user finished resizing
    // rebinds all the events
    let resizeTimer;
    window.addEventListener("resize", (ev) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        binds();
      }, 250);
    });

    this.searchBox.addEventListener("input", function () {
      if (document.getElementById("search-term").value == "") {
        setTimeout(() => {
          if (
            document
              .querySelector(".js-search-box")
              .classList.contains("active") &&
            document.getElementById("search-term").value == ""
          ) {
            document.querySelector(".js-search-box").classList.toggle("active");
          }
        }, 3000);
      }
    });
  }

  navScroll(e) {
    // Height of nav plus extra 150
    const navHeight = this.nav.offsetHeight + 150;

    // If the nav is animating then return
    if (this.scrollFromTop >= navHeight && this.navAnimating) return;

    // If the scrolled distance is higher than the nav height
    if (this.scrollFromTop >= navHeight) {
      // If the nav is not fixed do nothing, prevents constant firing
      if (!this.navFixed) {
        // No transition will prevent transition on first load
        this.nav.classList.add("c-hd--no-transition");
        this.nav.classList.add("c-hd--fixed");

        this.navFixed = true;

        // Activate the animating class so nothing else can happen
        // Remove the no transition class as we want it as the user scrolls down the page
        // Reset the animating
        this.navAnimating = true;
        setTimeout(() => {
          this.nav.classList.remove("c-hd--no-transition");
          this.navAnimating = false;
        }, 300);
      }
    }
    // If the nav needs to close again
    else {
      // Once the slide-in animation has finished we can unfix the nav
      this.navAnimating = true;

      // Remove the slide up class
      this.nav.classList.remove("c-hd--slide-in");

      setTimeout(() => {
        this.nav.classList.remove("c-hd--fixed");
        this.navAnimating = false;
        this.navFixed = false;
        //this.navSlideIn = false;
      }, 300);

      // Escape the function as we don't want to run any more scroll events as nav is is standard position
      return;
    }

    // The following if/else is responsible for the fade in/out of the nav as the user scrolls

    //If the the distance from top is lower than last scroll pos we are going upwards
    if (this.scrollFromTop < this.lastScrollFromTop) {
      // if the nav is fixed we can slide it in
      if (this.navFixed) this.nav.classList.add("c-hd--slide-in");
      this.navSlideIn = true;

      // if (scrollFromTop > navHeight) this.nav.classList.remove('c-hd--slide-in');
      // else this.nav.classList.add('c-hd--slide-in');
    } else {
      // We are going downwards so remove the slide
      this.nav.classList.remove("c-hd--slide-in");
      this.navSlideIn = false;
    }

    // Update the last scroll
    this.lastScrollFromTop = this.scrollFromTop;
  }

  pageNavScroll() {
    // If we are past the nav, plus an extra 50 (random value for visual purposes)
    if (this.scrollFromTop >= this.pageNavOffsetTop + 50) {
      // The page nav only needs to stick when at large breakpoint
      if (window.innerWidth < 1170) return;

      // Stick the nav, css fixes it to top of page
      this.pageNav.classList.add("stick");

      // Position the page nav where it needs to be
      if (this.navSlideIn && !this.navAnimating)
        this.pageNav.style.transform = "translateY(109px)";
      else this.pageNav.style.transform = "translateY(0)";

      // Set page nav to stick
      this.pageNavSticking = true;
    } else {
      if (!this.pageNavSticking) return;

      // Fade the nav out, move it back to the top and restet the variable
      this.pageNav.classList.add("fade-out");
      setTimeout(() => {
        this.pageNav.style.transform = "translateY(0)";
        this.pageNav.classList.remove("stick");
        this.pageNav.classList.remove("fade-out");
      }, 10);

      this.pageNavSticking = false;
    }
  }

  toggleSearch(e) {
    e.preventDefault();

    this.searchBoxActive = !this.searchBoxActive;

    this.searchBox.classList.toggle("active");

    if (this.searchBoxActive) trapFocus(this.searchBox);
    else this.searchBtn.focus();

    // this.searchBtn.addEventListener('keyup', function (e) {

    //     if (e.key === 'Tab' && document.querySelector('.js-search-box').classList.contains('active')) {
    //         console.log('somethings goott change');
    //         //document.querySelector('.c-search__text').focus();
    //     }

    // });
  }

  timeoutSearch() {
    if (
      this.searchBox.classList.contains("active") &&
      document.getElementById("search-term").value == ""
    ) {
      this.navTimeout = setTimeout(() => {
        if (
          this.searchBox.classList.contains("active") &&
          document.getElementById("search-term").value == ""
        ) {
          this.searchBox.classList.toggle("active");
        }
      }, 5000);
    } else {
      this.searchBox.classList.add("active");
    }

    if(this.searchOverlayClose){
      let navItems = document.querySelectorAll(".c-hd-nav__li--has-sub");
      navItems.forEach((item) => {
        item.addEventListener("mouseover", () =>{
          this.searchBox.classList.remove("active");
        });
      });
      this.searchOverlayClose = false;
    }
  }

  resetNav() {
    Array.from(document.querySelectorAll(".js-sub-nav-btn")).forEach((el) =>
      el.classList.remove("js-sub-nav-btn--active")
    );
    Array.from(document.querySelectorAll(".c-hd-nav__li-block")).forEach(
      (el) => {
        if (el.classList.contains("active")) {
          el.nextElementSibling.classList.remove("active");
          slideToggle(el.nextElementSibling);
        }
        el.classList.remove("active");
      }
    );
  }

  subNavClick(ev, btn) {
    // If it's a keypress and not enter return
    if (ev.type == "keydown" && ev.keyCode != 13) return;

    if (btn.parentElement.classList.contains("active")) {
      btn.parentElement.classList.remove("active");
      btn.parentElement.nextElementSibling.classList.remove("active");
    } else {
      this.resetNav();

      btn.parentElement.classList.add("active");
      btn.parentElement.nextElementSibling.classList.add("active");
    }

    if (window.innerWidth < this.navBP) {
      slideToggle(btn.parentElement.nextElementSibling);
    } else trapFocus(btn.parentElement.nextElementSibling, btn);

    var that = this;

    if (ev.type == "keydown" && ev.keyCode == 13) {
      // Using a funciton in this way allows me to unbind when the function has triggered
      window.addEventListener("click", function addCloseListener(ev) {
        console.log("window event listner");

        if (
          !ev.target.classList.contains("c-hd-nav__ul--sub") &&
          !ev.target.classList.contains("js-sub-nav-btn")
        ) {
          that.resetNav();
          window.removeEventListener("click", addCloseListener);
        }
      });
    }
  }

  navOpen() {
    this.navBtn.classList.add("disabled");
    toggleAria(this.navBtn, "aria-expanded");
    this.nav.classList.toggle("c-hd--nav-active");
    document.body.classList.toggle("nav-open");
    this.navBtn.classList.toggle("active");

    // Allow button to be clicked after it has finished
    setTimeout(() => {
      this.navBtn.classList.remove("disabled");
    }, 500);
  }

  navNoLinkClick(btn) {
    if (btn.nextElementSibling) this.subNavClick(btn.nextElementSibling);
  }
}
